import React from 'react';

import {
  ActionsCell,
  NameCell,
  SortCell,
  TagsCell,
} from '../../../../shared/components/DataTable';
import { DROPDOWN_ACTIONS } from '../../constants';
import { formatDate } from '../../utils';

const nameColumn = {
  accessorKey: 'fullName',
  cell: ({ row }) => <NameCell person={row.original} />,
  header: ({ column }) => <SortCell column={column} label="Name" />,
  meta: { className: 'w-full' },
};

const tagsColumn = {
  accessorKey: 'tags',
  cell: ({ getValue }) => <TagsCell tags={getValue()} />,
  header: 'Tags',
  meta: { className: 'min-w-48 text-right' },
};

const phoneColumn = {
  accessorKey: 'phone',
  header: 'Phone',
  meta: { className: 'min-w-36' },
};

const emailColumn = {
  accessorKey: 'email',
  header: ({ column }) => <SortCell column={column} label="Email" />,
  meta: { className: 'min-w-48' },
};

const addedAtColumn = {
  accessorKey: 'addedAt',
  cell: ({ getValue }) => formatDate(getValue()),
  header: ({ column }) => <SortCell column={column} label="Added" />,
  meta: { className: 'min-w-32' },
};

const actionsColumn = {
  cell: () => <ActionsCell actions={DROPDOWN_ACTIONS.client} />,
  id: 'actions',
};

const columns = [
  nameColumn,
  tagsColumn,
  phoneColumn,
  emailColumn,
  addedAtColumn,
  actionsColumn,
];

export default columns;
